var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 22,
    viewBox: "0 0 136 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 13.6443C0 11.7002 1.51781 10.1543 3.46261 10.1543C5.40742 10.1543 6.95393 11.7038 6.95393 13.6443C6.95393 15.5848 5.43612 17.1343 3.46261 17.1343C1.4891 17.1343 0 15.5848 0 13.6443Z",
    fill: "#33FF5E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.56287 0.301758H14.9954V9.69215L9.56287 10.4131V0.301758Z",
    fill: "#1A131E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.977 12.3244H32.807V16.9228H16.8467V12.3244H25.5481V8.83443C25.5481 6.37026 24.6331 4.59476 22.1967 4.59476C20.5605 4.59476 19.0642 5.23322 17.9555 5.84299L16.208 1.8831C18.3681 0.609766 20.6968 0 22.9144 0C28.2895 0 30.977 2.88025 30.977 8.36455V12.3244Z",
    fill: "#1A131E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9969 0.301758H38.4295V9.69215L32.9969 10.4131V0.301758Z",
    fill: "#1A131E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5699 8.11338C58.5699 13.9313 55.1073 17.3101 49.6461 17.3101C44.1848 17.3101 40.4746 13.9313 40.4746 8.11338V0.301205H45.9323V8.11338C45.9323 10.9649 47.3173 12.6292 49.6461 12.6292C51.9748 12.6292 53.1661 10.9685 53.1661 8.11338C53.1661 6.03659 52.5848 4.65206 51.0311 4.65206C50.0049 4.65206 49.5886 4.87445 48.871 5.17933L47.7084 1.07955C48.7598 0.498481 50.2022 0.0537109 51.8097 0.0537109C55.6886 0.0537109 58.5699 2.38158 58.5699 8.11338Z",
    fill: "#1A131E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0093 0.301439H76.4146V9.77432C76.4146 15.6747 73.562 17.1417 70.1532 17.1417C68.9332 17.1417 67.8818 17.0018 66.9094 16.697L67.602 12.2098C68.072 12.321 68.5708 12.4035 69.1808 12.4035C70.4546 12.4035 71.0359 11.8224 71.0359 9.65955V4.8962H60.0057V0.297852L60.0093 0.301439ZM65.5244 7.58634V21.0765H60.1493V8.14231L65.5244 7.58993V7.58634Z",
    fill: "#1A131E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6284 0.301758H84.061V9.69215L78.6284 10.4131V0.301758Z",
    fill: "#1A131E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9659 0.301758H91.3985V9.69215L85.9659 10.4131V0.301758Z",
    fill: "#1A131E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M107.467 12.3244H109.297V16.9228H93.3367V12.3244H102.038V8.83443C102.038 6.37026 101.123 4.59476 98.6867 4.59476C97.0505 4.59476 95.5542 5.23322 94.4455 5.84299L92.698 1.8831C94.8581 0.609766 97.1868 0 99.4043 0C104.779 0 107.467 2.88025 107.467 8.36455V12.3244Z",
    fill: "#1A131E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M116.136 0.301758V16.9197H110.703V0.301758H116.136Z",
    fill: "#1A131E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M136 16.6719V16.9193H130.069L124.722 9.74563C123.642 10.854 123.309 12.9881 123.391 16.9193H117.933C117.657 10.6029 119.096 7.61145 121.977 6.06193L117.876 0.548933V0.297852H123.779L129.125 7.47156C130.234 6.36323 130.539 4.22905 130.481 0.297852H135.939C136.215 6.61431 134.776 9.60574 131.895 11.1553L135.996 16.6683L136 16.6719Z",
    fill: "#1A131E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9533736af2f0a3a80a7339efbe174f07.svg";
export { ForwardRef as ReactComponent };